import EditableTickerTape from './EditableTickerTape';

export default EditableTickerTape;
